"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var message_service_1 = require("./message.service");
var ControlsTranslationService = /** @class */ (function () {
    function ControlsTranslationService(messageService) {
        this.messageService = null;
        this.messageService = messageService;
    }
    ControlsTranslationService.prototype.getMessage = function (key) {
        return this.messageService ? this.messageService.getMessage(key) : Observable_1.Observable.of(this.getReadableKey(key));
    };
    ControlsTranslationService.prototype.getMessageWithPlaceholder = function (key, placeholders) {
        return this.messageService ? this.messageService.getMessageWithPlaceholder(key, placeholders) : Observable_1.Observable.of(this.getReadableKey(key));
    };
    ControlsTranslationService.prototype.getReadableKey = function (key) {
        var parts = key.split('.');
        var text = parts[parts.length - 1].replace(/_/g, ' ');
        return text.charAt(0).toUpperCase() + text.slice(1);
    };
    ControlsTranslationService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()),
        __metadata("design:paramtypes", [message_service_1.MessageService])
    ], ControlsTranslationService);
    return ControlsTranslationService;
}());
exports.ControlsTranslationService = ControlsTranslationService;
//# sourceMappingURL=controls-translation.service.js.map